import { useState } from "react";

export default function useIsOver() {
  const [isOver, setIsOver] = useState(false);

  function onMouseEnter() {
    setIsOver(true);
  }

  function onMouseLeave() {
    setIsOver(false);
  }

  return { isOver, onMouseEnter, onMouseLeave };
  // return "It's over baby...";
}
